import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { getNaverBizItem, getNaverShopSearch } from "../api";
import { NaverKeys } from "../keys";
import { QUERY_TIME } from "constants/time";
import { NaverBizItemReq, NaverBizItemRes, NaverShopSearchReq, NaverShopSearchRes } from "../api.type";

type optionProps = { enabled?: boolean };

// 네이버 매장 검색
export const useNaverShopSearchQuery = (
  rootStore: any,
  payload: NaverShopSearchReq,
  options: optionProps = {}
): UseQueryResult<API.DefaultResponse<NaverShopSearchRes>> => {
  const isEnabled = options.enabled ?? true;

  return useQuery({
    queryKey: NaverKeys.shopInfo(payload),
    queryFn: () => getNaverShopSearch(rootStore, payload),
    enabled: isEnabled && !!payload.shopCd,
    staleTime: QUERY_TIME.ZERO_SECONDS,
    cacheTime: QUERY_TIME.ZERO_SECONDS,
    retry: false,
  });
};

// 주문 유형 조회
export const useNaverBizItemQuery = (
  rootStore: any,
  payload: NaverBizItemReq,
  options: optionProps = {}
): UseQueryResult<API.DefaultResponse<NaverBizItemRes>> => {
  const isEnabled = options.enabled ?? true;

  return useQuery({
    queryKey: NaverKeys.bizItem(payload),
    queryFn: () => getNaverBizItem(rootStore, payload),
    enabled: isEnabled && !!payload.shopCd && !!payload.businessId,
    staleTime: QUERY_TIME.FIVE_MINUTES,
    cacheTime: QUERY_TIME.TEN_MINUTES,
  });
};
